
export const Constants = {
    BASE_URL: process.env.REACT_APP_API_URL,
};

export interface ILoginModel {
    client_id: string;
    grant_type: string;
    username?: string;
    password?: string;
};

export interface ITokenModel {
    access_token: string;
    refresh_token: string;
};

export enum CognitoErrorCode {
    Unknown = 0,
    InternalErrorException = 1,
    InvalidLambdaResponseException = 2,
    InvalidParameterException = 3,
    InvalidSmsRoleAccessPolicyException = 4,
    InvalidSmsRoleTrustRelationshipException = 5,
    InvalidUserPoolConfigurationException = 6,
    MFAMethodNotFoundException = 7,
    NotAuthorizedException = 8,
    PasswordResetRequiredException = 9,
    ResourceNotFoundException = 10,
    TooManyRequestsException = 11,
    UnexpectedLambdaException = 12,
    UserLambdaValidationException = 13,
    UserNotConfirmedException = 14,
    UserNotFoundException = 15,
    NewPasswordRequired = 16,
    InvalidPasswordException = 17,
    CodeMismatchException = 18,
    LimitExceededException = 19
}




